// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1996":"f15bf3ef674c51b1","7260":"6d55cb3ed05457ef","9003":"0d93f43f5af5f61e"}[chunkId] + ".css";
};